export default __webpack_public_path__ + "static/media/window.5d7f2cb9.wav";